// extracted by mini-css-extract-plugin
export default {"tabs":"ScreenersPage_tabs__i+DlB","tab":"ScreenersPage_tab__a0Djy","list":"ScreenersPage_list__dtZzf","search":"ScreenersPage_search__HbJu7","content":"ScreenersPage_content__pc5FQ"};